<template>
  <modal
    :name="name"
    class="edit-event-modal show-more-options"
    :reset="true"
    :draggable="false"
  >
    <form v-on:submit.prevent="saveEvent()">
      <div class="modal-header">
        <div class="modal-header-btns">
          <button
            type="button"
            class="btn btn-link btn-with-icon"
            @click="hide"
          >
            <i class="icon-close"></i>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <div
          class="form-group"
          v-if="event.type === 'practice-lesson' && event.display_title"
        >
          <label class="form-text text-muted">{{ event.display_title }}</label>
        </div>
        <div class="form-group">
          <input
            class="form-control"
            id="titleInput"
            v-model="event.title"
            v-bind:placeholder="event.type === 'practice-lesson' ? texts.add_event_note : texts.add_event_title"
          />
        </div>
        <div class="form-group row">
          <div
            class="col-sm-6"
            v-if="action === 'edit' || action === 'schedule'"
          >
            <label class="form-check-label" for="start_date">{{
              texts.start_date
            }}</label>
            <date-input
              name="start_date"
              v-model="start_date"
              :required="true"
              :clear-button="false"
              @input="startDateChanged"
            ></date-input>

            <!-- <v-date-picker
              :input-props="{
                id: 'start_date',
                class: 'form-control',
                placeholder: datePlaceholder,
                //readonly: action === 'schedule'
              }"
              popover-visibility="focus"
              mode="date"
              :is-required="true"
              :formats="formats"
              @input="startDateChanged()"
              v-model="start_date"
            >
            </v-date-picker> -->
          </div>
          <div class="col-sm-3">
            <label class="form-check-label" for="start_time">{{ texts.start_hour }}</label>
            <input id="start_time" type="time" step="300" :value="start_time"
                   class="form-control" @input="onStartTimeChange($event.target.value)" />
          </div>
          <div class="col-sm-3">
            <label class="form-check-label" for="end_time">{{ texts.end_hour }}</label>
            <input id="end_time" type="time" step="300" :value="end_time"
                   class="form-control" @input="onEndTimeChange($event.target.value)" />
            <small class="form-text text-muted">{{ texts.duration || 'Durată' }}: {{ durationLabelText }}</small>
          </div>

          <div class="col-sm-3" v-if="hasPrice">
            <label class="form-check-label" for="price">{{
              texts.price
            }}</label>
            <input
              id="price"
              type="number"
              :value="price"
              class="form-control"
              @input="price = $event.target.value"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6" v-for="field in visibleExtraFields">
            <div
              class="form-group form-check mb-2"
              v-if="field.type == 'checkbox'"
            >
              <input
                type="checkbox"
                class="form-check-input"
                v-bind:id="field.name"
                v-model="event.extra_options[field.name]"
              />
              <label class="form-check-label" v-bind:for="field.name">{{
                field.title
              }}</label>
            </div>
            <div class="form-group" v-else>
              <label v-bind:for="field.name">{{ field.title }}</label>
              <input
                type="text"
                v-bind:id="field.name"
                v-model="event.extra_options[field.name]"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="form-group" v-if="show_more_options">
          <div class="form-check mb-2" v-if="canScheduleRecurringEvents">
            <input
              type="checkbox"
              class="form-check-input"
              id="is_recurring"
              v-model="is_recurring"
            />
            <label class="form-check-label" for="is_recurring">{{
              texts.repeat_event
            }}</label>
          </div>

          <div class="row" v-if="canScheduleRecurringEvents">
            <div class="col-sm-6 mb-1" v-if="is_recurring">
              <label class="form-check-label">{{ texts.days_of_week }}</label>
              <div class="form-row scheduled-days-badge">
                <span
                  class="badge m-1"
                  v-for="day in weekDays"
                  v-bind:class="{
                    'badge-primary': day.selected,
                    'badge-light': !day.selected,
                  }"
                  v-on:click="toggleWeekDay(day)"
                  >{{ day.name }}</span
                >
              </div>
            </div>

            <div class="col-sm-6 mb-1" v-if="is_recurring">
              <p>{{ texts.recurring_end }}</p>

              <div class="form-check mb-2">
                <input
                  type="radio"
                  class="form-check-input"
                  id="recurring_never_ends"
                  value="never"
                  name="recurring-end"
                  v-model="recurring_end"
                />
                <label class="form-check-label" for="recurring_never_ends">{{
                  texts.recurring_never_ends
                }}</label>
              </div>

              <div class="form-check mb-2">
                <input
                  type="radio"
                  class="form-check-input"
                  id="recurring_ends_on_date"
                  value="on-date"
                  name="recurring-end"
                  v-model="recurring_end"
                />
                <label class="form-check-label" for="recurring_ends_on_date">{{
                  texts.recurring_ends_on_date
                }}</label>

                <date-input
                  name="end_date"
                  v-model="end_date"
                  :required="true"
                  :clear-button="false"
                  @input="endDateChanged"
                ></date-input>

                <!-- <v-date-picker
                  :input-props="{
                    class: 'form-control',
                    placeholder: datePlaceholder,
                    readonly: recurring_end !== 'on-date',
                  }"
                  mode="date"
                  popover-visibility="focus"
                  :is-required="true"
                  :formats="formats"
                  @input="endDateChanged()"
                  v-model="end_date"
                >
                </v-date-picker> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer pull-right">
        <button
          type="button"
          class="btn btn-link"
          v-if="!show_more_options && hasMoreOptions"
          @click="show_more_options = true"
        >
          {{ texts.more_options }}
        </button>
        <button class="btn btn-success" :disabled="saving">{{ texts.save }}</button>
      </div>
    </form>
  </modal>
</template>

<script>
import ModalBase from "./ModalBase.vue";
import { WeekDays } from "../mixins/WeekDaysMixin";
import { EventTimeMixin } from "../mixins/EventTimeMixin";

export default {
  extends: ModalBase,
  mixins: [WeekDays, EventTimeMixin],

  props: {
    canScheduleRecurringEvents: {
      default: true,
    },
    timeMask: {
      default: "##:##",
    },
    datePlaceholder: {
      default: "ZZ/LL/AAAA",
    },
    timePlaceholder: {
      default: "--:--",
    },
    eventExtraFields: {
      default: () => [],
    },
    formats: {
      title: "MMMM YYYY",
      weekdays: "W",
      navMonths: "MMM",
      input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"], // Only for `v-date-picker`
      dayPopover: "L", // Only for `v-date-picker`
      data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"], // For attribute dates
    },
  },

  data() {
    return {
      event: {
        extra_options: {},
      },
      saving: false,
      start_date: new Date(),
      end_date: new Date(),
      start_time: "",
      end_time: "",
      price: "",
      is_recurring: false,
      show_more_options: true,
      recurring_end: "never",
    };
  },

  mounted() {
    console.log("Timetable Add Event Modal Component Mounted.");
    this.eventBus.$on("edit-event", this.editEvent);
  },

  methods: {
    editEvent(event, date) {
      this.event = {
        ...event,
      };
      console.log(this.event);
      this.is_recurring = event.is_recurring;
      this.price = event.price;
      this.start_date = moment(event.start_date).toDate();
      this.end_date = event.end_date ? new Date(event.end_date) : null;
      this.initEventTimes(
        moment(event.start_time).format("HH:mm"),
        moment(event.end_time).format("HH:mm")
      );

      if (this.end_date) {
        this.recurring_end = "on-date";
      }

      this.initWeekDays();

      if (event.recurring_pattern && event.recurring_pattern.days_of_week) {
        event.recurring_pattern.days_of_week.forEach((day) => {
          this.weekDays[day - 1].selected = true;
        });
      }

      if (_.isEmpty(this.event.extra_options)) {
        this.event.extra_options = {};
      }

      this.show();
    },

    saveEvent() {
      // Nothing disabled the button, so a double click sent the update twice.
      if (this.saving) return;

      this.createEventData();
      this.saving = true;

      // The modal used to hide immediately and re-open on failure, so a failed save
      // looked like a success for as long as the request took. Stay open until the
      // server answers, then close only if it actually succeeded.
      this.eventBus.$emit("update-event", this.event, (err) => {
        this.saving = false;

        if (!err) this.hide();

        this.eventBus.$emit("update-events-force");
      });
    },

    startDateChanged() {
      if (this.end_date && this.start_date > this.end_date) {
        this.end_date = this.start_date;
      }
    },

    endDateChanged() {
      if (this.end_date && this.end_date < this.start_date) {
        this.start_date = this.end_date;
      }
    },

    createEventData() {
      let start_date = moment(this.start_date);
      let end_date = moment(this.end_date);
      let start_time = moment(start_date);
      let end_time = moment(start_date);
      let _start_time = moment(this.start_time, "HH:mm");
      let _end_time = moment(this.end_time, "HH:mm");

      start_time.hour(_start_time.hour());
      start_time.minute(_start_time.minute());

      end_time.hour(_end_time.hour());
      end_time.minute(_end_time.minute());

      // Use start time for start date to fix timezone issues??
      this.event.start_date = this.formatDate(start_time);
      this.event.start_time = this.formatDate(start_time);
      this.event.end_time = this.formatDate(end_time);
      this.event.is_recurring = this.is_recurring;
      this.event.price = this.price;

      if (this.is_recurring) {
        if (this.recurring_end == "on-date") {
          this.event.end_date = this.formatDate(end_date.clone().endOf("day"));
        } else {
          this.event.end_date = null;
        }

        this.event.recurring_pattern = {
          recurring_type_id: "weekly",
          days_of_week: this.selectedWeekDays,
        };
      } else {
        this.event.recurring_pattern = null;
      }
    },

    formatDate(date) {
      return date.format();
    },
  },
  computed: {
    // The panel behind "Mai multe opțiuni" holds nothing but the recurring-event
    // section, so where recurring events are off the button opened an empty panel.
    hasMoreOptions() {
      return this.canScheduleRecurringEvents;
    },

    // "Nu s-a prezentat" / "Nu a achitat" / "Nu necesită evaluare" live on the
    // student's pivot row, so on an event with nobody attached (a custom event,
    // a reservation) they have nothing to write to.
    visibleExtraFields() {
      const hasStudent = (this.event.attached_user_ids || []).length > 0;

      return this.eventExtraFields.filter(
        (field) => hasStudent || !field.requires_student
      );
    },

    hasPrice() {
      // Only booked lessons and exams are paid for; templates, vacations and
      // custom events have nothing to charge.
      return ['practice-lesson', 'internal-exam'].includes(this.event.type);
    },

    selectedWeekDays() {
      return this.weekDays
        .filter((day) => day.selected)
        .map((day) => day.number);
    },
  },

  filters: {
    pad(num) {
      if (num < 10) return "0" + num;
      return num;
    },
  },

  watch: {},
};
</script>
<style>
.edit-event-modal.v--modal-overlay .v--modal-box {
  overflow: visible;
}

.edit-event-modal.v--modal-overlay {
  position: initial;
}

.edit-event-modal .v--modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 1090 !important;
}

.btn-close-modal {
  border-radius: 50%;
  padding: 0;
  width: 30px;
  height: 30px;
  box-sizing: content-box;
  position: absolute;
  right: 1px;
  top: 1px;
  z-index: 10000;
  background: white;
}

.btn-close-modal:hover {
  background: #fdfdfd;
}

.btn-close-modal i {
  font-size: 20px;
  margin: 0;
}

.scheduled-days-badge .badge {
  padding: 10px;
  font-size: 100%;
}
</style>
